export const AppConfig = {
  site_name: 'Storage Vault',
  title: 'Depotium',
  description: 'For Storage purpose',
  locale: 'en',
  brand: 'dp',
  brand_name: 'depotium',
};
